import onboardingEmail from 'api/onboarding/email/onboardingEmail.js';

const store = {
    namespaced: true,
    state: {
        recommendedUsers: [],
        id: 0,
        name: '',
        forename: '',
        email: '',
        senderEmail: '',
        locale: '',
        timezone: '',
        type: '',
        phoneNumber: '',
        isAdmin: '',
        isCreator: false,
        notifications: null,
        pendingEmail: null,
        emailIsVerified: false,
        isOnboardingSetup: false,
        permissions: null,
        agendaProvider: 'sellsy',
        uiLang: '',
    },
    getters: {
        getUser: (state) => state,
        getPendingEmail: (state) => state.pendingEmail,
        getPermissions: (state) => state.permissions,
        getCurrentUserId: (state) => state.id,
        getIsAdmin: (state) => state.isAdmin,
    },
    mutations: {
        setRecommendedUsers(state, payload) {
            state.recommendedUsers = payload;
        },
        setNotifications(state, payload) {
            state.notifications = payload;
        },
        setSenderEmail(state, email) {
            state.senderEmail = email;
        },
        setPendingEmail(state, payload) {
            state.pendingEmail = payload;
        },
        setEmailIsVerified(state, payload) {
            state.emailIsVerified = payload;
        },
        setIsOnboardingSetup(state, payload) {
            state.isOnboardingSetup = payload;
        },
    },
    actions: {
        setRecommendedUsers({ commit }, payload) {
            commit('setRecommendedUsers', payload);
        },
        setNotifications({ commit }, payload) {
            commit('setNotifications', payload);
        },
        updateSenderEmail({ commit }, email) {
            commit('setSenderEmail', email);
        },
        updatePendingEmail({ commit }, payload) {
            commit('setPendingEmail', payload);
        },
        updateEmailIsVerified({ commit }, payload) {
            commit('setEmailIsVerified', payload);
        },
        updateIsOnboardingSetup({ commit }, payload) {
            commit('setIsOnboardingSetup', payload);
        },
        sendVerificationEmail({ commit }, { email, redirectUrl = null }) {
            return new Promise((resolve, reject) => {
                onboardingEmail
                    .sendVerificationEmail(email, redirectUrl)
                    .then((response) => {
                        if (response.status === 204) {
                            commit('setPendingEmail', email);
                            resolve({
                                type: 'success',
                                message: window.sellsyapp.config.globalProperties.$l10nn.__(
                                    'Lien de vérification envoyé par email',
                                ),
                            });
                        }
                    })
                    .catch((error) => {
                        if (error.code === 500) {
                            reject({
                                type: 'error',
                                message: window.sellsyapp.config.globalProperties.$l10nn.__(
                                    'Service email temporairement indisponible, merci de réessayer ultérieurement',
                                ),
                            });
                        } else if (error.code === 409) {
                             
                            const timeToRetry = moment
                                .duration(error.details.retryAfter, 'seconds')
                                .humanize();
                            reject({
                                type: 'informative',
                                message: window.sellsyapp.config.globalProperties.$l10nn.__(
                                    'Lien de vérification déjà envoyé, merci de patienter %(timeToRetry)s avant de réessayer',
                                    { timeToRetry: timeToRetry },
                                ),
                            });
                        }
                    });
            });
        },
    },
};

const factory = (user = {}) => {
    return {
        ...store,
        state: {
            id: user.id,
            name: user.name,
            forename: user.forename,
            email: user.email,
            senderEmail: user.senderEmail,
            locale: user.locale,
            timezone: user.timezone,
            type: user.type,
            phoneNumber: user.phoneNumber,
            isAdmin: user.isAdmin,
            isCreator: user.isCreator,
            notifications: null,
            pendingEmail: null,
            emailIsVerified: false,
            permissions: user.permissions,
            agendaProvider: user.agendaProvider,
            uiLang: user.uiLang,
        },
    };
};

export { store as default, factory };
